import React, { useRef, useState } from "react";
import { Skeleton } from "antd";
import Slider from "react-slick";

const CarouselSlide: React.FC<{ src: string; alt: string }> = ({ src, alt }) => {
  const [loaded, setLoaded] = useState(false);
  return (
    <div className="itinerary-carousel__slide">
      {!loaded && (
        <div className="itinerary-carousel__skeleton">
          <Skeleton.Image active style={{ width: "100%", height: "100%" }} />
        </div>
      )}
      <img
        src={src}
        alt={alt}
        style={{ display: loaded ? "block" : "none" }}
        onLoad={() => setLoaded(true)}
      />
    </div>
  );
};

const ImageCarousel: React.FC<{ images: string[]; title: string; initialSlide?: number }> = ({
  images,
  title,
  initialSlide = 0,
}) => {
  const sliderRef = useRef<Slider>(null);
  const [currentSlide, setCurrentSlide] = useState(0);

  React.useEffect(() => {
    if (initialSlide > 0 && sliderRef.current) {
      sliderRef.current.slickGoTo(initialSlide, true);
      setCurrentSlide(initialSlide);
    }
  }, [initialSlide]);

  const multi = images.length > 1;

  return (
    <div className="itinerary-carousel">
      <Slider
        ref={sliderRef}
        dots={false}
        arrows={false}
        infinite={multi}
        autoplay={multi}
        autoplaySpeed={3500}
        pauseOnHover
        speed={300}
        slidesToShow={1}
        slidesToScroll={1}
        afterChange={(idx) => setCurrentSlide(idx)}
      >
        {images.map((src, i) => (
          <CarouselSlide key={i} src={src} alt={`${title} ${i + 1}`} />
        ))}
      </Slider>
      {multi && (
        <>
          <div className="itinerary-carousel__dots">
            {images.map((_, i) => (
              <button
                key={i}
                className={`itinerary-carousel__dot${i === currentSlide ? " active" : ""}`}
                onClick={() => sliderRef.current?.slickGoTo(i)}
              />
            ))}
          </div>
          <button className="itinerary-carousel__arrow itinerary-carousel__arrow--prev" onClick={() => sliderRef.current?.slickPrev()}>&#8249;</button>
          <button className="itinerary-carousel__arrow itinerary-carousel__arrow--next" onClick={() => sliderRef.current?.slickNext()}>&#8250;</button>
        </>
      )}
    </div>
  );
};

export default ImageCarousel;
